import React  from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Switch, Link } from 'react-router-dom'
import { push } from 'react-router-redux'

import { PrivateRoute } from '../../Auth'
import { logout } from '../../Auth/actions'


import {
	permission,
	PERMISSIONS_NONE,
	LIST_SOLUTIONS, SOLUTIONS,
	LIST_ORGANISATIONS, ORGANISATIONS,
	LIST_USERS, USERS,
	LIST_DATASOURCES, DATASOURCES,
	LIST_ROLES, ROLES,
	LIST_PREDICTIONS, PREDICTIONS, 
	READ_PREDICTION, PREDICTION, 
	LIST_GROUPS, GROUPS,
	LIST_EXECUTIONS, EXECUTIONS,
	
} from '../../actions/permissions'

import { Home } from './Home'
import { GroupsPage } from './Groups'
import { RolesPage } from './Roles'
import { SolutionsPage } from './Solutions'
import { UserProfilePage, UsersAdminPage } from './User'
import { PredictionConfigsPage } from './PredictionConfigs'
import { PredictionConfigEditor } from '../SolutionEditor/Predictions/PredictionConfigEditor'
import { OrganisationsPage } from './Organisations'
import { ExecutionsPage } from './Executions'
import { DatasourcesPage } from './Datasources'

import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { Tooltip, CssBaseline, Divider, List, Typography, Toolbar, 
	AppBar, IconButton, Avatar, Menu, MenuItem, 
	Button, Drawer, ListItem, ListItemIcon, ListItemText} from '@material-ui/core'


import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import DashboardIcon from '@material-ui/icons/Dashboard'
import ProfileIcon from '@material-ui/icons/AccountCircle'
import GroupIcon from '@material-ui/icons/Group'
import RolesIcon from '@material-ui/icons/GroupWork'
import OrganisationsIcon from '@material-ui/icons/Domain'
import UsersIcon from '@material-ui/icons/Person'
import DatasourcesIcon from '@material-ui/icons/Folder'
import SolutionsIcon from '@material-ui/icons/Widgets'
import PredictionsIcon from '@material-ui/icons/PlayCircleOutline'
import ExecutionsIcon from '@material-ui/icons/Flag'

import styles from '../../styles'

const privateRoutes = [
	{ name: 'Dashboard', path: '/admin', urlMatcher :'^/admin$', exact: true, component: Home, icon: DashboardIcon, permission: PERMISSIONS_NONE },
	{ name: 'Profile', path: '/admin/profile', component: UserProfilePage,  icon: ProfileIcon, permission: PERMISSIONS_NONE },
	{ name: 'Organisations', path: '/admin/organisations', component: OrganisationsPage, icon: OrganisationsIcon, permission: LIST_ORGANISATIONS, link: ORGANISATIONS },
	{ name: 'Groups', path: '/admin/groups', component: GroupsPage,  icon: GroupIcon, permission: LIST_GROUPS, link: GROUPS },
	{ name: 'Roles', path: '/admin/roles', component: RolesPage, icon: RolesIcon, permission: LIST_ROLES, link: ROLES },
	{ name: 'Users', path: '/admin/users', component: UsersAdminPage, icon: UsersIcon, permission: LIST_USERS, link: USERS },
	{ name: 'Datasources', path: '/admin/datasources', component: DatasourcesPage,  icon: DatasourcesIcon, permission: LIST_DATASOURCES, link: DATASOURCES },
	{ name: 'Solutions', path: '/admin/solutions', component: SolutionsPage,  icon: SolutionsIcon, permission: LIST_SOLUTIONS, link: SOLUTIONS },
	{ name: '', path: '/admin/predictions/configs/:id', urlMatcher : '^/admin/predictions/configs/.*$',component: PredictionConfigEditor,  permission: READ_PREDICTION, link: PREDICTIONS },
	{ name: 'Predictions', path: '/admin/predictions/configs', exact: true, component: PredictionConfigsPage,  icon: PredictionsIcon, permission: LIST_PREDICTIONS, link: PREDICTION },
	{ name: 'Executions', path: '/admin/executions', component: ExecutionsPage,  icon: ExecutionsIcon, permission: LIST_EXECUTIONS, link: EXECUTIONS },
]


export class AdminPage extends React.Component {
	state = {
		anchorEl: null,
		selected: this.props.location.pathname,
		open: true
	};

	handleClick = event => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleClose = () => {
		this.setState({ anchorEl: null });
	};


	handleDrawerOpen = () => {
		this.setState({ open: true });
	};

	handleDrawerClose = () => {
		this.setState({ open: false });
	};

	handleItemClick = (e, path) => {
		e.preventDefault()
		this.setState({
			selected: path
		})
		this.props.push(path)
	}

	currentRoute = () => {
		return privateRoutes.find(i => (this.props.location.pathname.match(new RegExp(i.urlMatcher || i.path))))
	}

	render() {
		const { classes,  } = this.props
		const { anchorEl } = this.state
		const currentRoute =  this.currentRoute(this.state.selected)
		return (
			<React.Fragment>
				<CssBaseline />
				<div className={classes.root}>
					<AppBar
						position="absolute"
						className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
					>
						<Toolbar disableGutters={!this.state.open} className={classes.toolbar}>
							<IconButton
								color="inherit"
								aria-label="Open drawer"
								onClick={this.handleDrawerOpen}
								className={classNames(
									classes.menuButton,
									this.state.open && classes.menuButtonHidden,
								)}
							>
								<MenuIcon />
							</IconButton>
							<Typography
								component="h1"
								variant="h6"
								color="inherit"
								noWrap
								className={classes.title}
							>
							 {this.props.title || currentRoute.name }
							</Typography>

							<div>
        <Button className={classes.avatar_button}
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        > 
		<Tooltip title={<div>{this.props.user._embedded.firstName} {this.props.user._embedded.lastName}
			<br/>
			{this.props.user._embedded.emailAddress}
			</div>}>
          	<Avatar className={classes.avatar}>{this.props.user._embedded.firstName[0]+this.props.user._embedded.lastName[0]}</Avatar>
		  </Tooltip>
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleClose}>Profile</MenuItem>
          <MenuItem onClick={this.handleClose}>My account</MenuItem>
          <MenuItem><Button onClick={()=> {

			   this.props.logout()
			}}>Logout</Button> </MenuItem>
        </Menu>
      </div>
						</Toolbar>
					</AppBar>
					<Drawer
						variant="permanent"
						classes={{
							paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
						}}
						open={this.state.open}
					>
						<div className={classes.toolbarIcon}>
						<div className= {classes.logo} >DICIDIO</div>
							<IconButton onClick={this.handleDrawerClose}>
								<ChevronLeftIcon />
							</IconButton>
						</div>
						<Divider />
						<List>
							<div className={classes.drawerMenu}>
								{
									privateRoutes.map(i => (
										(permission(this.props.user, i.permission) && i.icon)?
											< ListItem key={i.name} button
												component={Link} to={i.path}
												onClick={e => this.handleItemClick(e, i.path)}
												selected={this.state.selected.match(new RegExp(i.urlMatcher || i.path)) !== null }>
												<ListItemIcon>
													<i.icon />
												</ListItemIcon>
												<ListItemText primary={i.name} />
											</ListItem>
											: null
									))
								}</div>
						</List>
						<Divider />
						<List>{/* secondaryListItems */}</List>
					</Drawer>
					<main className={classes.adminContent}>
						<div className={classes.appBarSpacer} />
						<Switch>
							{
								privateRoutes.map(item => <PrivateRoute key={item.path} {...item} />)
							}

						</Switch>
					</main>
				</div>

			</React.Fragment>
		);
	}
}


AdminPage = connect(
	state => ({
		user: state.user.profile,
		title :state.adminPage.title,
		
	}),
	dispatch => (
		bindActionCreators({ push, logout }, dispatch)
	)
)(withStyles(styles, { withTheme: true })(AdminPage))




// WEBPACK FOOTER //
// ./src/App/Admin/AdminPage.jsx